import { useEffect, useState } from "react";
import INTOUCH_API from "../../../../services/Api";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import useAuth from "../../../../hooks/useAuth";
import PersonalAccount from "../../../../store/PersonalAccount";
import useCookie from "../../../../hooks/useCookie";
import ROUTES from "../../../../utils/routes";
import { TEMPORARY_ID_KEY } from "../../../../utils/constants";
import useBrowserStorage from "../../../../hooks/useBrowserStorage";
import { useLocation } from "react-router-dom";
import useCurrentGame from "../../../../hooks/useCurrentGame";

export default function useController() {
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isFieldsEmpty, setIsFieldsEmpty] = useState(false);
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [incorrectPairMessage, setIncorrectPairMessage] = useState("");
  const { navigateTo } = useCustomNavigate();
  const { setToken } = useAuth();
  const { getCurrentGame } = useCurrentGame();
  const { getCookie, removeCookie } = useCookie();
  const { getItem, removeItem } = useBrowserStorage();
  const location = useLocation();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setLoginForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateFormData = (formData) => {
    return Object.values(formData).some((input) => !input.length);
  };

  const onSubmitHandle = async (event) => {
    if (isLoginLoading) return;
    event.preventDefault();
    const formData = { ...loginForm, email: loginForm.email.toLowerCase() };
    const isFormDataEmpty = validateFormData(formData);
    if (isFormDataEmpty) {
      setIsFieldsEmpty(true);
      setTimeout(() => setIsFieldsEmpty(false), 5000);
      return;
    }
    const temporaryUserId = getItem(TEMPORARY_ID_KEY);
    if (temporaryUserId) {
      formData.temporaryUserId = temporaryUserId;
    }
    await login(formData);
  };

  const login = async (formData) => {
    if (isLoginLoading) return;
    setIsLoginLoading(true);
    await INTOUCH_API.requestManager(
      "login",
      formData,
      async (response) => {
        const invite_link = getCookie("invite_link");
        // const errorLink = getCookie("errorLink");
        const temporaryUserId = getItem(TEMPORARY_ID_KEY);
        // если есть temporaryUserId значит была начата тестовая игра с лендинга и посещен экран "Знакомство с собой"
        // тут записываем что посетили его, т.к логика
        if (temporaryUserId) {
          const game = getCurrentGame();
          if (game?.id) {
            await PersonalAccount.addGameIdsByMeets(
              game.id,
              response.data.userId
            );
          }
        }

        removeItem("ref", "session");
        removeCookie("inviterGender");

        removeCookie("errorLink");

        setToken(response.data.token);
        await PersonalAccount.getPersonalAccountData();

        if (invite_link) {
          navigateTo(`${ROUTES.LANDING_PAGE}?link=${invite_link}`, {
            replace: true,
          });
          removeCookie("invite_link");
          return;
        }
        removeItem(TEMPORARY_ID_KEY);

        if (
          location.state &&
          location.state.buttonType &&
          location.state.buttonType === "buyGame"
        ) {
          navigateTo(ROUTES.PAYMENT_PAGE, {
            replace: true,
            state: { productType: location.state.productType },
          });
          return;
        }

        navigateTo(ROUTES.PERSONAL_ACCOUNT_PAGE, { replace: true });
      },
      (error) => {
        setIncorrectPairMessage(error.response?.data.message);
        setTimeout(() => setIncorrectPairMessage(""), 5000);
      }
    ).finally(() => {
      setIsLoginLoading(false);
    });
  };

  useEffect(() => {
    return () => {
      setIsLoginLoading(null);
    };
  }, []);
  return {
    onSubmitHandle,
    loginForm,
    isLoginLoading,
    isFieldsEmpty,
    incorrectPairMessage,
    handleChange,
  };
}
